"use client"

import * as React from "react"

import { cn } from "../../lib/utils"

function Table({ className, ...props }: React.ComponentProps<"table">) {
  return (
    <div
      data-slot="table-container"
      className={"[container-type:inline-size] [position:relative] [width:100%] [min-width:0] [max-width:100%] [overflow-x:auto] [overscroll-behavior-inline:none] [border-radius:6px] [border-width:1px] [border-style:solid] [border-color:var(--color-border-secondary)] [background-color:var(--color-bg-elevated)] [background-clip:padding-box] [&_table]:[border-collapse:collapse] [&_table]:[border-spacing:0] [&_table]:[table-layout:auto!important]"}
    >
      <table
        data-slot="table"
        className={cn(
          "[width:max-content] [min-width:100%] [caption-side:bottom] [border-collapse:collapse] [border-spacing:0] [font-size:0.8125rem] [line-height:1.125rem] [color:var(--color-text-secondary)]",
          className
        )}
        {...props}
      />
    </div>
  )
}

function TableHeader({ className, ...props }: React.ComponentProps<"thead">) {
  return (
    <thead
      data-slot="table-header"
      className={cn(
        "[border-color:var(--color-border-secondary)] [&_tr]:[border-bottom-width:1px] [&_tr]:[border-bottom-style:solid] [&_tr]:[border-bottom-color:var(--color-border-secondary)]",
        className
      )}
      {...props}
    />
  )
}

function TableBody({ className, ...props }: React.ComponentProps<"tbody">) {
  return (
    <tbody
      data-slot="table-body"
      className={cn("[&_tr:last-child]:[border-width:0]", className)}
      {...props}
    />
  )
}

function TableFooter({ className, ...props }: React.ComponentProps<"tfoot">) {
  return (
    <tfoot
      data-slot="table-footer"
      className={cn(
        "[border-top-width:1px] [border-top-style:solid] [border-top-color:var(--color-border-secondary)] [background-color:var(--color-tint-secondary)] [font-weight:500]",
        className
      )}
      {...props}
    />
  )
}

function TableRow({ className, ...props }: React.ComponentProps<"tr">) {
  return (
    <tr
      data-slot="table-row"
      className={cn(
        "[border-bottom-width:1px] [border-bottom-style:solid] [border-bottom-color:var(--color-border-secondary)] [font-size:0.8125rem] [line-height:1.125rem] hover:[color:var(--color-text-primary)] [&[data-state=selected]]:[background-color:var(--color-tint-secondary)]",
        className
      )}
      {...props}
    />
  )
}

function TableHead({ className, ...props }: React.ComponentProps<"th">) {
  return (
    <th
      data-slot="table-head"
      className={cn(
        "[background-color:var(--color-tint-secondary)] [color:var(--color-text-primary)] [padding-block:0.625rem] [padding-inline:0.5rem] sm:[padding-inline:1rem] [text-align:left] [vertical-align:middle] [font-weight:500] [white-space:nowrap] [font-size:0.8125rem] [line-height:1.125rem] [&:has([role=checkbox])]:[padding-right:0rem] [&>[role=checkbox]]:[transform:translateY(2px)]",
        className
      )}
      {...props}
    />
  )
}

function TableCell({ className, ...props }: React.ComponentProps<"td">) {
  return (
    <td
      data-slot="table-cell"
      className={cn(
        "[padding-block:0.75rem] [padding-inline:0.5rem] [vertical-align:middle] [white-space:nowrap] sm:[padding-inline:1rem] group-hover:[color:var(--color-text-primary)] [&:has([role=checkbox])]:[padding-right:0rem] [&>[role=checkbox]]:[transform:translateY(2px)]",
        className
      )}
      {...props}
    />
  )
}

function TableCaption({
  className,
  ...props
}: React.ComponentProps<"caption">) {
  return (
    <caption
      data-slot="table-caption"
      className={cn(
        "[margin-top:1rem] [font-size:0.8125rem] [line-height:1.125rem] [color:var(--color-text-secondary)]",
        className
      )}
      {...props}
    />
  )
}

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
}
